
























import { mixins } from "vue-class-component";
import { Component, Vue, Prop } from "vue-property-decorator";
import { NavBar, Cell, CellGroup, Button } from "vant";
import DemoBlock from "@/components/DemoBlock.vue";
import DemoSection from "@/components/DemoSection.vue";
import WeMixin from "@/components/weMixin";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    DemoBlock,
    DemoSection,
  },
})
export default class DemoAuthPage extends mixins(WeMixin) {
  @Prop({ default: false })
  private user?: boolean;

  get msg(): string {
    return !this.user ? "auth:true权限" : 'auth:"user"权限';
  }

  protected onClick() {
    api
      .get("/weixinmp/info", {
        weLoading: true,
        // weRegister: true,
        weBindUser: true,
      } as WeAxiosRequestConfig)
      .then((response) => {
        this.$dialog.alert({
          message: response.data.username,
        });
      });
  }
}
